(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.fundHoldingToggle = {
    attach: function (context, settings) {
      const $toggle = $('.data--fund-holding__toggle', context);
      const $div = $toggle.next('div');

      // Show the next div when toggle is clicked.
      $toggle.click(function (event) {
        event.preventDefault();
        $toggle.hide();
        $div.slideDown();
      });
    }
  }
})(jQuery, Drupal);
